exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".season-list{display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;margin-top:40px}", "", {"version":3,"sources":["C:/projects/Infrastil/evm/evm-frontend-react/src/components/Season/SeasonList/SeasonList.scss"],"names":[],"mappings":"AAEA,aACE,oBAAqB,AACrB,aAAc,AACd,mBAAoB,AAChB,eAAgB,AACpB,eAAiB,CAAE","file":"SeasonList.scss","sourcesContent":["/* COLOR PALETTE */\n/* SIZINGS */\n.season-list {\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  margin-top: 40px; }\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":false,"sourceMap":true,"minimize":true}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/lib/loader.js!./src/components/Season/SeasonList/SeasonList.scss
// module id = 1551
// module chunks = 0